import { SVGProps } from 'react';

const CircleArrowOutUpRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M22 12A10 10 0 1 1 12 2m10 0L12 12m10-4V2h-6"
    />
  </svg>
);
export default CircleArrowOutUpRight;
